"use client"

import { NavLink, Link } from "react-router-dom"
import { FaCalendarAlt, FaMoneyBillWave, FaTags, FaSignOutAlt, FaUser } from "react-icons/fa"
import { useAuth } from "../context/AuthContext"
import "./Navbar.css"

const Navbar = () => {
  const { currentUser, logout, isAuthenticated } = useAuth()

  const handleLogout = () => {
    logout()
  }

  return  isAuthenticated ? (<>
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <h1>Plantaozão</h1>
        </div>

        {isAuthenticated ? (
          <>
            <ul className="navbar-menu">
              <li className="navbar-item">
                <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")}>
                  <FaCalendarAlt />
                  <span>Calendário</span>
                </NavLink>
              </li>
              <li className="navbar-item">
                <NavLink to="/payments" className={({ isActive }) => (isActive ? "active" : "")}>
                  <FaMoneyBillWave />
                  <span>Pagamentos</span>
                </NavLink>
              </li>
              <li className="navbar-item">
                <NavLink to="/tags" className={({ isActive }) => (isActive ? "active" : "")}>
                  <FaTags />
                  <span>Etiquetas</span>
                </NavLink>
              </li>
            </ul>

            <div className="navbar-user">
              <span className="user-name">
                <FaUser className="user-icon" /> {currentUser.name}
              </span>
              <button className="logout-btn" onClick={handleLogout}>
                <FaSignOutAlt /> <span className="logout-text">Sair</span>
              </button>
            </div>
          </>
        ) : (
          <div className="auth-buttons">
            <Link to="/login" className="btn btn-outline">
              Entrar
            </Link>
            <Link to="/register" className="btn btn-primary">
              Cadastrar
            </Link>
          </div>
        )}
      </div>
    </nav>
  )
    </>) : <></>

}

export default Navbar

